export default "__VITE_ASSET__89c29c6b__"